import StaffPositionComponent from "components/Settings/StaffPosition";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { mapDispatchToProps } from "store/helpers/mapDispatch";
import { mapStateToProps } from "store/helpers/mapState";

function StaffPosition({  SetSelectedMenu }) {

   

    useEffect(() => {
        SetSelectedMenu({
            menu: "positions",
            title: "Positions"
        })
    }, []);





    return <StaffPositionComponent />
}

export default connect(mapStateToProps, mapDispatchToProps)(StaffPosition);